import Styles from './NodeJenkins.module.scss';
import NodeAutomationStyles from '../NodeAutomation/NodeAutomation.module.scss';
import Style from '../../../../components/footer/footer.tailwind.js';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { useParams, useNavigate } from 'react-router';

// Module imports.
import axios from 'axios';
import {
	Avatar, Typography, Fab, Backdrop,
	LinearProgress, Box, Badge, Dialog
} from '@mui/material';
import { ClickAwayListener } from '@mui/base';
import { pink } from '@mui/material/colors';
import { ToastContainer, toast } from 'react-toastify';
import TerminalIcon from '@mui/icons-material/Terminal';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RuleIcon from '@mui/icons-material/Rule';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import 'react-toastify/dist/ReactToastify.css';
import 'react-chat-widget/lib/styles.css';

// Components import.
import { useAPI, AuthContext, Feedback, ViewContext } from 'components/lib';
import { Joyride } from 'components/walkthrough/walkthrough';
import InfoDrawer from 'components/global/NodeLayout/InfoDrawer.js';
import { HelperChat } from 'components/global/HelperChat/HelperChat';
import { NodeTimeline } from 'components/global/NodeLayout/NodeTimeline';
import { LightTooltip } from 'components/global/NodeLayout/NodeTopostman';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard.js';
import { BackConfirmationCard } from 'components/global/BackConfirmationCard/BackConfirmationCard';
import CodeEditorStyles from '../NodeCodeEditor/NodeCodeEditor.module.scss';

// Util imports
import { decoder } from 'utils/helpers/decoder';
import { copyEnabledChecker } from 'utils/helpers/utility';
import { InstructionPane } from 'components/global/InstructionPane/InstructionPane';
import ContainerLoader from 'components/ContainerLoader/ContainerLoader';

const finalAudio = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/media/git/voice/finish_node.mp3`;

export const NodeJenkins = (props) => {

	const navigate = useNavigate();
	const { node_id } = useParams();
	const { lab_id } = useParams();
	const { resource } = useParams();
	const context = useContext(AuthContext);
	const { data, loading } = useAPI(`/api/labs/${lab_id}/nodes/${node_id}/${resource}`, 'GET');

	const [nodeInfo, setNodeInfo] = useState(data);
	const [currentStep, setCurrentStep] = useState(0);
	const [steps, setSteps] = useState();
	const [nodeFinished, setNodeFinished] = useState(false);
	const [isMuted, setIsMuted] = useState(true);
	const currentRef = useRef(null);
	const sessionId = localStorage.getItem('sessionId');
	const [startLab, setStartLab] = useState(true);
	const [loadingContainerStart, setLoadingContainerStart] = useState(false);
	const [progress, setProgress] = useState(0);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [showFinishConfirm, setShowFinishConfirm] = useState(false);
	const [userPublicIp, setUserPublicIp] = useState();
	const [showIP, setShowIP] = useState(false);
	const [ipAddress, setIPAddress] = useState(props.t('Labs.Nodes.NodeJenkins.useState.ipAddress'));
	const [verifyError, setVerifyError] = useState(props.t('Labs.Nodes.NodeJenkins.useState.errorMessage'));
	const [outputTitle, setOutputTitle] = useState('');
	const [clickedShowIP, setClickedShowIP] = useState(false);
	const [maximizeGif, setMaximizeGif] = useState(false);
	const [showReloadConfirm, setShowReloadConfirm] = useState(false);
	const [copied, setCopied] = useState(false);
	const outputRef = useRef(null);
	const roundedPercentage = nodeFinished ? 100 : Math.ceil((currentStep / nodeInfo?.numOfSteps) * 100);
	const activityTimerRef = useRef(null);
	const isCopyEnabled = copyEnabledChecker(context?.user);
	const startActivityTimer = () => {
		activityTimerRef.current = setTimeout(handleInactivity, 900000);
	};
	const [maxUnlocked, setMaxUnlocked] = useState(0);
	const audioRef = useRef(null);
	const finalAudioRef = useRef(null);
	const viewContext = useContext(ViewContext)


	useEffect(() => {
		setMaxUnlocked(prev => Math.max(prev, currentStep));
	}, [currentStep]);

	const resetActivityTimer = () => {
		clearTimeout(activityTimerRef.current);
		startActivityTimer();
	};

	function handleInactivity() {
		setShowReloadConfirm(true);
		handleContainerDelete();
	}

	const handleContainerDelete = () => {
		const sessId = localStorage.getItem('sessionId');
		const options = {
			method: 'DELETE',
			url: `/api/container-instances`,
			data: { "sessionId": sessId },

			headers: {
				accept: 'application/json',
			},
		};

		axios
			.request(options)
			.then(async function (response) {
				localStorage.removeItem('sessionId');
			})
			.catch((err) => {
				console.log(err)
			});
			
	};

	const handleVoiceClick = () => {
		resetActivityTimer();
		setIsMuted(!isMuted);
	};

	const handleRefresh = () => {
		window.location.reload();
	};

	const handleGoBack = () => {
		navigate(-1);
	};


	useEffect(() => {
		if (loadingContainerStart) {
			const interval = setInterval(() => {
				setProgress((prevProgress) => (prevProgress >= 95 ? 100 : prevProgress + 0.5));
			}, 1000);

			if (!loadingContainerStart) {
				clearInterval(interval);
			}
			return () => {
				clearInterval(interval);
			};
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loadingContainerStart]);

	useEffect(() => {
		if (!steps) return;

		if (audioRef.current) {
			audioRef.current.pause();
		}

		const audioLink = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}${steps[currentStep]?.voice}`;
		if (audioLink && !isMuted) {
			const newAudio = new Audio(audioLink);
			audioRef.current = newAudio;
			newAudio.play();
		}

		return () => {
			if (audioRef.current) {
				audioRef.current.pause();
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentStep, isMuted]);

	useEffect(() => {
		if (!nodeFinished) return;

		if (audioRef.current) {
			audioRef.current.pause();
		}

		const audio = new Audio(finalAudio);
		finalAudioRef.current = audio;
		audio.play();

		viewContext.notification.show(
			props.t('Labs.Nodes.NodeJenkins.end'),
			'info',
			false
		);

		return () => {
			if (finalAudioRef.current) {
				finalAudioRef.current.pause();
			}
		};

	}, [nodeFinished])

	useEffect(() => {
		if (data) {
			const jsonData = decoder(data);
			jsonData.numOfSteps = jsonData.steps.steps.length;
			setNodeInfo(jsonData);
			setSteps(jsonData.steps.steps);
			document.title = props.t('Labs.Nodes.NodeJenkins.title', { nodeName: jsonData.name })

		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	const handleFinish = () => {
		const formData = {
			sessionId: sessionId,
		};
		const options = {
			method: 'POST',
			url: `/api/user/labs/${lab_id}/nodes/${node_id}/end`,
			headers: {
				accept: 'application/json',
			},
			data: {
				...formData,
				...(nodeInfo.is_assessment === 1 && { completionPercent: roundedPercentage }),
			},
		};

		axios
			.request(options)
			.then(async function (response) {
				await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen
				if (nodeInfo.is_assessment === 1) {
					navigate(`/labs/${lab_id}/nodes`);
				} else {
					navigate(`/labs/${lab_id}/nodes/${node_id}/quiz/attempt`);
				}
				localStorage.removeItem('sessionId');
			})
			.catch((err) => {
				navigate('/oops');
			});
	};
	const startLabClick = async () => {
		startActivityTimer();
		setLoadingContainerStart(!loadingContainerStart);
		const formData = {
			resource: nodeInfo.resource,
		};
		const options = {
			method: 'POST',
			url: `/api/user/labs/${lab_id}/nodes/${node_id}/start`,
			headers: {
				accept: 'application/json',
			},
			data: formData,
		};
		await axios
			.request(options)
			.then((response) => {
				new Promise((resolve) => setTimeout(resolve, 100));
				setLoadingContainerStart(false);
				setStartLab(false);
				setUserPublicIp(response.data.user_ip);
				localStorage.setItem('sessionId', response.data.session_id);
				setIPAddress(`http://${decoder(response.data.user_ip)}:8080`);
				if (context?.user?.stop_walkthrough?.includes(nodeInfo?.resource?.lab_resource_id) || nodeInfo.is_assessment === 1) {
					setIsMuted(!isMuted)
				}
			})
			.catch((err) => {
				if (err.response.status === 403) {
					navigate('/nopermission');
				} else {
					navigate('/oops');
				}
			});
	};
	const handleGifClick = () => {
		setMaximizeGif(true);
		resetActivityTimer();
	};
	const navigateBack = () => {
		navigate(-1);
	};

	const handleShowIP = async () => {
		resetActivityTimer();
		setOutputTitle('IP Address:');
		setShowIP(true);
		setClickedShowIP(true);
	};

	function handleVerify() {
		resetActivityTimer();
		setOutputTitle('Error:');
		const formData = {
			user_ip: userPublicIp,
			command: steps[currentStep].command,
			timeline: steps[currentStep].timeline,
			jenkins_method: steps[currentStep].jenkins_method,
			verify_method: steps[currentStep].verify_method,
			expected_resource: steps[currentStep].expected_resource,
			xpath: steps[currentStep].xpath,
			property_name: steps[currentStep].property_name,
			job_name: steps[currentStep].job_name,
		};
		const options = {
			method: 'POST',
			url: `/api/container-instances/jenkins/verify`,
			headers: {
				accept: 'application/json',
			},
			data: formData,
		};
		function htmlDecode(input) {
			const e = document.createElement('textarea');
			e.innerHTML = input;
			return e.value;
		}
		axios
			.request(options)
			.then(function (response) {
				// not sure what this does commented out
				// if (response.data && response.data.message) {
				// 	const decodedMessage = htmlDecode(response.data.message);
				// }
				if (currentStep !== nodeInfo.numOfSteps - 1) {
					setCurrentStep(currentStep + 1);
					var myElement = document.getElementById('currenttimelineHolder');
					var topPos = myElement.offsetTop;
					document.getElementById('timelinescrolldiv').scrollTop = topPos;
				} else {
					setNodeFinished(true);
				}
			})
			.catch((err) => {
				let status = err?.response?.status;
				if (status === 406) {
					setShowIP(true);
					setVerifyError(htmlDecode(err.response.data.error)); // Decode error message
				} else if (status === 500) {
					setShowIP(true);
					setVerifyError(htmlDecode(err.response.data.error)); // Decode error message
				} else {
					navigate('/oops');
				}
			});
	}

	const handleDrawer = () => {
		resetActivityTimer();
		setDrawerOpen(!drawerOpen);
	};

	const resetWalkthrough = (data) => {
		if ((data.status === 'finished') | (data.action === 'skip') | (data.action === 'tour:end')) {
			setIsMuted(!isMuted);
		}
	};
	useEffect(() => {
		const resourceIncluded = context?.user?.stop_walkthrough?.includes(nodeInfo?.resource?.lab_resource_id);
		if (resourceIncluded && !startLab) {
			setIsMuted(!isMuted);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [context?.user?.stop_walkthrough]);

	const sendHeartbeat = () => {
		const formData = {
			node_id: node_id,
		};
		const options = {
			method: 'POST',
			url: `/api/container-instances/heartbeat`,
			headers: {
				accept: 'application/json',
			},
			data: formData,
		};

		axios
			.request(options)
			.then(function (response) {
			})
			.catch((err) => {
				console.log(err.response.status);
			});
	};

	useEffect(() => {
		//send heartbeat call every 4 mins
		const heartBeatId = setInterval(sendHeartbeat, 240000);

		return () => {
			clearInterval(heartBeatId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const openInNewTab = (url) => {
		const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
		if (newWindow) newWindow.opener = null;
	};

	const handleCopyButton = async () => {
		try {
			await navigator.clipboard.writeText(steps[currentStep]?.command);
			setCopied(true);
			setTimeout(() => {
				setCopied(false);
			}, 2000);
			toast.dark(props.t('Labs.Nodes.NodeAutomation.toast.warn'), {
				type: 'warning',
				position: 'top-right',
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
		} catch (error) {
			toast.dark(props.t('Labs.Nodes.NodeAutomation.copyCode.alert'), {
				type: 'error',
				position: 'top-right',
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
		}
	}

	const handleCopy = async (e) => {
		setCopied(true);
		setTimeout(() => {
			setCopied(false);
		}, 2000);
		toast.dark(props.t('Labs.Nodes.NodeAutomation.toast.warn'), {
			type: 'warning',
			position: 'top-right',
			autoClose: 3000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		});
	};

	const handleCopyDisabled = (e) => {
		e.preventDefault();
	}

	return (
		<>
			{/* container loading animation */}
			<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loadingContainerStart}>
				{!startLab && nodeInfo.is_assessment !== 1 ? (
					<Joyride
						open={nodeInfo?.resource?.walkthrough?.open}
						run={nodeInfo?.resource?.walkthrough?.run}
						steps={nodeInfo?.resource?.walkthrough?.steps || []}
						resourceId={nodeInfo?.resource?.lab_resource_id}
						disableOverlay={true}
						callback={resetWalkthrough}
					/>
				) : null}
				<ContainerLoader 
					progress={progress} 
					loadingContainerStart={loadingContainerStart} 
					containerHints={nodeInfo?.container_loader_json} 
				/>
			</Backdrop>
			{loading ? (
				<div>
					<LoadingBackdrop isOpen={true} />
				</div>
			) : steps ? (
				<>
					<ToastContainer
						id="warning-toast"
						position="top-right"
						autoClose={10000}
						hideProgressBar={false}
						newestOnTop
						closeOnClick
						pauseOnFocusLoss
						draggable
						pauseOnHover
						limit={4}
					/>
					<ConfirmationCard
						title={props.t("Labs.Nodes.NodeTerminal.confirm.timeout.title")}
						body={props.t("Labs.Nodes.NodeTerminal.confirm.timeout.body")}
						showCard={showReloadConfirm}
						setShowCard={setShowReloadConfirm}
						handleCancel={handleGoBack} // Pass the refresh handler
						handleConfirm={handleRefresh} // Pass the go back handler
						confirmButtonText={props.t('Labs.Nodes.NodeJenkins.confirm.button.refresh')}
						cancelButtonText={props.t('Labs.Nodes.NodeJenkins.confirm.button.goBack')}
					/>



					<ConfirmationCard
						title={nodeInfo.is_assessment ? props.t("Labs.Nodes.NodeJenkins.confirm.start.title.assessment") : props.t("Labs.Nodes.NodeJenkins.confirm.start.title.default")}
						body={props.t("Labs.Nodes.NodeJenkins.confirm.start.body")}
						showCard={startLab}
						setShowCard={setStartLab}
						handleCancel={navigateBack}
						handleConfirm={startLabClick}
					/>


					<BackConfirmationCard
						isSaveAvailable={false}
						isContainerLab={true}
						sessionId={sessionId}
					/>
					<div id="titleContainer" className={Styles.titleContainer}>
						<span style={{ display: 'flex' }}>
							<Avatar
								sx={{
									bgcolor: pink[500],
									alignSelf: 'center',
									mr: 1,
									width: 55,
									height: 55,
								}}
							>
								<TerminalIcon sx={{ width: 42, height: 42 }} />
							</Avatar>
							<Typography
								variant="h3"
								sx={{
									textTransform: 'uppercase',
									color: '#FFFFFF',
								}}
							>
								{nodeInfo.name}
							</Typography>
						</span>
						<div id="finishButtonContainer" className={Styles.finishButtonContainer}>
							<span style={{ display: 'flex', flexDirection: 'row' }}>
								<LightTooltip
									title={nodeFinished ? props.t("Labs.Nodes.NodeJenkins.tooltip.finish.node") : props.t("Labs.Nodes.NodeJenkins.tooltip.finish.assessment")}
									arrow
									placement="left"
									classes={{
										tooltip: {
											backgroundColor: '#fff',
											color: 'rgba(0, 0, 0, 0.87)',
											boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
											fontSize: 11,
										},
									}}
								>
									<span>
										<button
											variant="extended"
											className={Styles.finishButton}
											onClick={() => {
												nodeInfo.is_assessment ? setShowFinishConfirm(true) : handleFinish();
											}}
											disabled={!nodeFinished}
										>
											<KeyboardDoubleArrowRightIcon />
											{props.t('Labs.Nodes.NodeJenkins.button.finish')}
										</button>
									</span>
								</LightTooltip>
								<ConfirmationCard
									title={props.t('Labs.Nodes.NodeJenkins.confirm.completed.title')}
									body={props.t('Labs.Nodes.NodeJenkins.confirm.completed.body')}

									showCard={showFinishConfirm}
									setShowCard={setShowFinishConfirm}
									handleConfirm={handleFinish}
								/>
							</span>

							<div id="infoDrawer" className={Styles.fabContainer} onClick={handleDrawer}>
								<LightTooltip
									title={props.t("Labs.Nodes.NodeJenkins.tooltip.reference")}
									arrow
									placement="left"
									classes={{
										tooltip: {
											backgroundColor: '#fff',
											color: 'rgba(0, 0, 0, 0.87)',
											boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
											fontSize: 11,
										},
									}}
								>
									<Fab color="primary" size="medium">
										<LightbulbIcon />
									</Fab>
								</LightTooltip>
							</div>
						</div>
					</div>
					<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={showIP}>
						<div
							id="outputWindow"
							ref={outputRef}
							className={`${CodeEditorStyles.outputWindow} ${Styles.outputWindow}`}
							style={{ marginTop: '20px', fontFamily: 'monospace' }}
						>
							<div style={{ width: '100%', display: 'flex' }}>
								<div
									style={{
										display: 'flex',
										width: '100%',
										justifySelf: 'flex-start',
										fontSize: '16px',
										fontWeight: '600',
									}}
								>
									{outputTitle}
								</div>
								<div style={{ display: 'flex', width: '100%', justifySelf: 'flex-end', justifyContent: 'flex-end' }}>
									<Badge
										aria-label="Close Explanation"
										badgeContent={<CloseIcon className={Styles.closeBadge} sx={{ fontSize: 30 }} />}
										anchorOrigin={{
											vertical: 'top',
											horizontal: 'right',
										}}
										onClick={() => setShowIP(false)}
										sx={{
											cursor: 'pointer',
										}}
									></Badge>
								</div>
							</div>
							{outputTitle === 'IP Address:' ? (
								<div>
									<div
										style={{ display: 'flex', }}>
										<p>{props.t('Labs.Nodes.NodeJenkins.output.title')} </p>
										<div
											className={Style.link}
											style={{
												cursor: 'pointer',
											}}
											onClick={() => openInNewTab(ipAddress)}
										>
											{ipAddress}
										</div>
									</div>
									<div>
										<p>{props.t('Labs.Nodes.NodeJenkins.output.username')}'aivagam_user'</p>
										<p>{props.t('Labs.Nodes.NodeJenkins.output.password')}'aivagam'</p>
									</div>
								</div>
							) : (
								<div>{verifyError}</div>
							)}
						</div>
					</Backdrop>
					<div id="midContainer" className={Styles.midContainer}>
						<div id="gifAndInstructionContainer" className={Styles.gifAndInstructionContainer}>
							<div id="gifAncestorContainer">
								<div id="buttonContainer" className={Styles.button}>
									<LightTooltip
										title={props.t("Labs.Nodes.NodeJenkins.tooltip.info")}
										arrow
										placement="left"
										classes={{
											tooltip: {
												backgroundColor: '#fff',
												color: 'rgba(0, 0, 0, 0.87)',
												boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
												fontSize: 11,
											},
										}}
									>
										<button id="showIPButton" className={NodeAutomationStyles.ButtonStyles} onClick={handleShowIP}>
											{props.t('Labs.Nodes.NodeJenkins.button.show')} <VisibilityIcon fontSize="small" />
										</button>
									</LightTooltip>
									<LightTooltip
										title={clickedShowIP && props.t('Labs.Nodes.NodeJenkins.tooltip.verify')}
										arrow
										placement="left"
										classes={{
											tooltip: {
												backgroundColor: '#fff',
												color: 'rgba(0, 0, 0, 0.87)',
												boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
												fontSize: 11,
											},
										}}
									>
										<span>
											<button
												id="verifyButton"
												className={NodeAutomationStyles.ButtonStyles}
												onClick={handleVerify}
												disabled={!clickedShowIP}
											>
												{props.t('Labs.Nodes.NodeJenkins.button.verify')} <RuleIcon />
											</button>
										</span>
									</LightTooltip>
								</div>
								<div id="gifContainer" className={Styles.gifContainer}>
									<img
										src={
											`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${nodeInfo?.steps?.steps[currentStep]?.gif_link}`
												? `${process.env.REACT_APP_GLOBAL_MEDIA_URL}${nodeInfo?.steps?.steps[currentStep]?.gif_link}`
												: `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/media/jenkins/gifs/jenkins_default.png`
										}
										alt="gif"
										className={Styles.gif}
										onClick={handleGifClick}
									/>
								</div>
							</div>
							<div data-testid="nodeJenkins-midContainer-infoContainer" id="infoContainer" className={Styles.infoContainer}>
								<InstructionPane
									props={props}
									steps={steps}
									currentStep={currentStep}
									isMuted={isMuted}
									copied={copied}
									setIsMuted={setIsMuted}
									isCopyEnabled={isCopyEnabled}
									onHandleCopy={handleCopy}
									onHandleVoiceClick={handleVoiceClick}
									onHandleCopyDisabled={handleCopyDisabled}
									onHandleCopyButton={handleCopyButton}
									nodeInfo={nodeInfo}
									showLineNumbers={false}
									theme="light"
								/>
							</div>
							<span data-testid="nodeJenkins-midContainer-codeEditorTimeLine" id="codeEditorTimeLine" className={Styles.codeEditorTimeLine}>
								<NodeTimeline
									nodeFinished={nodeFinished}
									currentStep={currentStep}
									steps={steps}
									currentRef={currentRef}
									hideToolTip={false}
									collapsable={true}
									setCurrentStep={setCurrentStep}
									maxUnlocked={maxUnlocked}
								/>
							</span>
						</div>
					</div>
					<InfoDrawer
						handleDrawer={handleDrawer}
						drawerOpen={drawerOpen}
						titleText={props.t('Labs.Nodes.NodeJenkins.reference', { LabName: nodeInfo.labName })}
						displayData={nodeInfo?.content?.reference_data}
					/>
					<Dialog
						fullWidth={true}
						maxWidth={window.innerWidth > 1280 ? 'lg' : 'md'}
						open={maximizeGif}
						PaperProps={{
							style: {
								overflow: 'hidden',
							},
						}}
					>
						<ClickAwayListener onClickAway={() => setMaximizeGif(false)}>
							<div onClick={() => setMaximizeGif(false)} className={Styles.iframe}>
								<img
									src={
										`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${nodeInfo?.steps?.steps[currentStep]?.gif_link}`
											? `${process.env.REACT_APP_GLOBAL_MEDIA_URL}${nodeInfo?.steps?.steps[currentStep]?.gif_link}`
											: `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/media/jenkins/gifs/jenkins_default.png`
									}
									alt="dialog-gif"
									className={Styles.dialogGif}
								/>
							</div>
						</ClickAwayListener>
					</Dialog>
					{(!startLab && !nodeFinished && nodeInfo.is_assessment !== 1 && nodeInfo?.resource?.config?.chatbotTopic) && (
						<HelperChat
							active={props.aiChat}
							topic={nodeInfo?.resource?.config?.chatbotTopic}
						/>
					)}
					{nodeFinished && <Feedback isInNode={true} nodeName={nodeInfo.name} labName={nodeInfo.labName} />}

				</>
			) : (
				<div>
					<LoadingBackdrop isOpen={true} />
				</div>
			)}
		</>
	);
};
